var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullScreen",attrs:{"id":"fullScreen"}},[_c('img',{staticClass:"rotating",attrs:{"src":require('@/assets/svg/spaceman.svg')}}),_vm._v(" "),_c('div',{staticClass:"pagenotfound-text"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("Page lost in space")])])],1),_vm._v(" "),_c('canvas',{attrs:{"id":"canvas2d","width":"1589","height":"764"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1f4bd60","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 102
// module chunks = 0